/**
 * @generated SignedSource<<3a665156ba4958a9a711aeafde08c310>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HighlightsPanel_note$data = {
  readonly id: string;
  readonly isLocked: boolean;
  readonly title: string;
  readonly viewerCanEdit: boolean;
  readonly " $fragmentType": "HighlightsPanel_note";
};
export type HighlightsPanel_note$key = {
  readonly " $data"?: HighlightsPanel_note$data;
  readonly " $fragmentSpreads": FragmentRefs<"HighlightsPanel_note">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HighlightsPanel_note",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isLocked",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerCanEdit",
      "storageKey": null
    }
  ],
  "type": "Note",
  "abstractKey": null
};

(node as any).hash = "7a87e9ba178d14e253dd26665417ede2";

export default node;
